import React from "react";
import { EMAIL_ENTITY_TYPE } from "@miplatform/constants";
import {
  CalendarType,
  IAttemptListItemResponseForWorkOrder,
  IAttemptListResponse,
} from "@miplatform/types";
import { EmailActivityPreviewModal } from "@mibuildweb/components";
import { Box } from "@mui/material";
import { useCalendarContext } from "../../providers";
import { OrdersEmailDrawer } from "../Orders/OrdersEmailDrawer/OrdersEmailDrawer";
import { useOrdersContext } from "../Orders/OrdersProvider";
import { HoldsListCalendar } from "./HoldsListCalendar";
import { KanbanCalendar } from "./KanbanCalendar";
import { NHCPriorityScheduler } from "./NHCPriorityScheduler/NHCPriorityScheduler";
import { SingleDayScheduler } from "./SingleDayScheduler";
import { WorkOrderAttemptDrawer } from "./WorkOrderAttemptDrawer/WorkOrderAttemptDrawer";

export const CalendarRenderer: React.FC<CalendarRendererProps> = ({
  setSelectedOrder,
  orderReasons,
}) => {
  const {
    emailDrawer,
    emailPreview,
    handleEmailDrawerClose,
    handleEmailPreviewModalClose,
  } = useOrdersContext();

  const {
    date,
    selectedAttempt,
    setSelectedAttempt,
    refreshData,
    getTrayDataForCalendar,
    calendarConfig,
    calendarSet,
  } = useCalendarContext();

  const handleHoldsRefresh = () => {
    refreshData();
    getTrayDataForCalendar();
  };

  if (!calendarConfig) {
    return null;
  }

  const renderCalendar = () => {
    switch (calendarConfig.calendarType) {
      case CalendarType.Scheduler:
        return (
          <SingleDayScheduler
            calendar={calendarConfig}
            date={date}
            calendarSet={calendarSet}
          />
        );
      case CalendarType.PriorityScheduler:
        return <NHCPriorityScheduler />;
      case CalendarType.Kanban:
        return (
          <KanbanCalendar
            setSelectedOrder={setSelectedOrder}
            orderReasons={orderReasons}
          />
        );
      case CalendarType.HoldsList:
        return (
          <HoldsListCalendar
            onRefresh={handleHoldsRefresh}
            orderReasons={orderReasons}
          />
        );
      default:
        return <Box>Unknown calendar type: {calendarConfig.calendarType}</Box>;
    }
  };

  return (
    <>
      {renderCalendar()}
      {emailDrawer && (
        <OrdersEmailDrawer
          // @ts-expect-error fixing this error will require to change the OrdersEmailDrawer to typescript
          open={emailDrawer.isOpen}
          entity={emailDrawer.order}
          entityType={EMAIL_ENTITY_TYPE.ORDER}
          templateType={emailDrawer.templateType}
          onClose={handleEmailDrawerClose}
        />
      )}
      {selectedAttempt && (
        <WorkOrderAttemptDrawer
          key={selectedAttempt.id}
          open={!!selectedAttempt}
          listAttempt={selectedAttempt}
          onClose={() => setSelectedAttempt(null)}
        />
      )}
      {emailPreview && (
        <EmailActivityPreviewModal
          isEmailModalOpen
          activity={emailPreview}
          details={emailPreview}
          closeEmailModal={handleEmailPreviewModalClose}
        />
      )}
    </>
  );
};

interface CalendarRendererProps {
  setSelectedOrder: (
    order:
      | IAttemptListResponse
      | IAttemptListItemResponseForWorkOrder
      | undefined
  ) => void;
  orderReasons: {
    holdReasons: { value: string; label: string }[];
    rescheduleReasons: { value: string; label: string }[];
  };
}
